(() => {
	angular.module('main').directive('modalThanks', modalThanks);

	modalThanks.$inject = ['$timeout', '$location'];

	function modalThanks($timeout, $location) {
		return {
			restrict: 'E',
			template: `
            <div id="thanksModal" class="modal modal-center fade" tabindex="-1" role="dialog" data-keyboard="false">
                <div class="modal-dialog modal-welcome">
                    <div class="modal-content">
                        <div class="ninja-logo-wrapper"> <img src="https://app.studioninja.co/build/master-59/resources/dist/assets/images/email/logo-questionnaire-complited.png" alt="" style="position: absolute; left: calc(50% - 40px); top: 0;"> </div>
                        <h2>Thank you! Your subscription is confirmed.</h2>
                        <div class="flex-row flex-wrap-xs flex-just-center">
                            <button type="button" class="btn btn-block btn-accept btn-lg" data-toggle="modal" ng-click="hideThanks()">Get back to work </button> <i class="hidden-xs ps-10"></i>
                            <button type="button" class="btn btn-block btn-grey-light btn-lg" data-toggle="modal" ng-click="goToAccount()"> Go to Account Settings </button>
                        </div>
                    </div>
                </div>
            </div>
        `,
			scope: {},
			replace: true,
			transclude: true,
			link(scope) {
				scope.hideThanks = function() {
					$('#thanksModal').modal('hide');
				};

				scope.goToAccount = function() {
					$('#thanksModal').modal('hide');
					$timeout(() => {
						$location.path('/settings/profile');
					}, 300);
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/modalThanks.js